import React from 'react';
import PropTypes from 'prop-types';

const StatusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1000" height="1000" version="1" viewBox="0 0 750 750">
    <path
      fill="#4360DF"
      d="M3498 7410c-643-43-1342-294-1870-671-307-220-548-455-841-821-68-85-226-349-311-519C194 4836 67 4270 83 3645c12-459 89-839 254-1260C729 1390 1541 611 2555 261c269-93 564-161 797-182 165-15 760-5 926 15 509 64 1077 281 1532 586 436 292 866 745 1110 1170 280 487 442 980 502 1530 16 149 16 572-1 720-69 631-260 1170-594 1670-453 678-1073 1159-1847 1434-238 84-551 160-784 191-146 19-515 27-698 15zm982-2060c257-27 460-119 616-282 131-136 194-256 228-438 47-244-19-479-177-633-147-143-323-201-697-227-186-14-319-9-625 22-274 29-673 31-810 5-128-24-119-29-112 57 22 259 141 581 305 826 96 144 285 338 418 427 207 140 423 222 643 243 111 11 108 11 211 0zm-775-1790c212-26 625-23 823 6 49 8 47 28 12-161-92-508-415-958-838-1169-262-131-600-172-837-101-187 55-387 182-482 307-49 63-105 179-124 258-22 92-15 251 15 346 90 282 376 482 746 523 101 12 571 5 685-9z"
      transform="matrix(.1 0 0 -.1 0 750)"
    />
  </svg>
);

StatusIcon.propTypes = {};

export default StatusIcon;
